import React from "react";
import cardStyles from './Card.module.css';
import styles from './CardSkeleton.module.css';
import classNames from "classnames";
import { ENV } from "../../../env";

const CardSkeleton = () => {
  return (
    <div className = { classNames(cardStyles.offersCard, styles.skeletonCard, ENV.FEATURE_FLAGS.isMapAvailable ? '' : cardStyles.offersCardHalfWidth) }>
      <div className = { classNames(cardStyles.cardImageChip, styles.skeletonChip) }>
        <div className = { styles.skeletonChipIcon }></div>
        <div className = { styles.skeletonChipText }></div>
      </div>
      <div className = { styles.skeletonImage }></div>
      <div className = { cardStyles.cardContent }>
        <div className = { cardStyles.cardInfo }>
          <div className = { styles.skeletonTitle }></div>
          <div className = { styles.skeletonRating }></div>
          <div className = { styles.skeletonDescription }></div>
          <div className = { styles.skeletonLink }></div>
        </div>
        <div className = { cardStyles.cardFooter }>
          <div className = { cardStyles.priceContainer }>
            <div className = { cardStyles.priceRow }>
              <div className = { styles.skeletonPrice }></div>
              <div className = { styles.skeletonUnit }></div>
            </div>
            <div className = { styles.skeletonFee }></div>
          </div>
          <div className = { styles.skeletonButton }></div>
        </div>
      </div>
    </div>
  );
};

export default CardSkeleton;
